import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/core/services/data.service';
import { UtilService } from 'src/app/core/services/util.service';
import { ModalComponent } from '../modal/modal.component';

export interface UserData {
  id: string;
  email: string;
  action: string;
}

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit, AfterViewInit {
  userForm: FormGroup;
  userList;
  displayedColumns: string[] = ['id', 'email', 'scope', 'action'];
  dataSource: MatTableDataSource<UserData>;
  filter = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  userRole = new FormControl('admin', [Validators.required]);
  loggedInUser = this.utilService.getUsername();
  pattern =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  unknownErrMsg = '';
  userNotFoundErrMsg = '';
  userAddedMsg = '';

  constructor(
    public dataService: DataService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private utilService: UtilService,
    public translate: TranslateService
  ) {
    this.translate
      .stream(['UNKNOWN_MSG', 'USERS.NOT_FOUND_ERR', 'USERS.USER_ADDED_MSG'])
      .subscribe((res) => {
        this.unknownErrMsg = res['UNKNOWN_MSG'];
        this.userNotFoundErrMsg = res['USERS.NOT_FOUND_ERR'];
        this.userAddedMsg = res['USERS.USER_ADDED_MSG'];
      });
  }

  ngOnInit() {
    this.utilService.checkIfLoggedIn();

    this.userList = [];

    this.userForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      // userRole: new FormControl('admin', [Validators.required]),
    });
  }

  ngAfterViewInit() {
    // fetch user list
    this.getUsersList();

    if (this.sort) {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    }
  }

  getUsersList() {
    this.spinner.show();

    this.dataService.getUsers().subscribe(
      (res) => {
        if (res && res !== null && res.length > 0) {
          this.userList = res;
          this.userList.map((user, index) => {
            user.id = index + 1;
            user.action = 'delete';
            user.email = user.uuid;
            return user;
          });
          // console.log(this.userList);
          this.dataSource = new MatTableDataSource(this.userList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  hasError = (controlName: string, errorName: string) => {
    return this.userForm.controls[controlName].hasError(errorName);
  };

  // adddelete user
  manageUser(action, user) {
    let username;

    if (action === 'create') {
      username = this.userForm.get('username').value;

      if (!this.pattern.test(username)) {
        this.openModalPopUp('Please enter a valid email address.', false);
        return false;
      }
    } else {
      username = user;
    }
    this.spinner.show();
    const scope =
      this.userRole.value.toLowerCase() === 'admin' ? 'repair-admin' : 'repair';

    const request = {
      username,
      action,
      scope,
    };

    this.dataService.manageUser(request).subscribe(
      (res) => {
        this.spinner.hide();

        if (
          res &&
          res !== null &&
          res !== undefined &&
          res.hasOwnProperty('status') &&
          res.status === 200
        ) {
          if (res.hasOwnProperty('body') && res.body !== null) {
            if (res.body.hasOwnProperty('message')) {
              this.openModalPopUp(res.body.message, false, true);
            } else {
              const message = `User ${username} ${this.userAddedMsg}\n  username: ${username},\n password: ${res.body.password}`;
              // const message = `User ${username} is successfully registered \nin Repair Tool. Following are the credentials:\n  username: ${username},\n password: ${res.body.password}`;
              this.openModalPopUp(message, true, true);
            }
            this.userForm.reset();
          } else {
            this.openModalPopUp(this.userNotFoundErrMsg, false);
          }
        } else {
          this.openModalPopUp(this.unknownErrMsg, false);
        }
      },
      (err) => {
        this.spinner.hide();
        console.log(err);
        // err.message ||
        const message = this.unknownErrMsg;
        this.openModalPopUp(message, false);
      }
    );
  }

  // modal pop-ups for showing warning/error messaages
  openModalPopUp(bodyText, isPreTag, fetch = false) {
    if (bodyText) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        message: bodyText,
        isPreTag,
      };
      this.dialog
        .open(ModalComponent, dialogConfig)
        .afterClosed()
        .subscribe((res) => {
          // console.log(res);
          if (fetch) {
            // this.dataSource.filter = '';
            this.filter = '';
            this.getUsersList();
          }
        });
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
